import md5 from 'md5';

import { csrfMatches } from '../../utils/csrfMatches';
import { readCookie } from '../../utils/cookies-browser';
import { requestApi, NotLoggedInError } from './apiRequest';
import { getLoginUrl } from '../../utils/urlUtils';
import clientApiCache from '../../utils/clientApiCache';

const getLang = lang => lang || (readCookie('lang') || 'en').toLowerCase();
export const getDeviceInfo = async () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const wfp = await import('../../utils/wfp');
  return {
    'device-info': wfp.getInfo(),
  };
};

const gwRequest = async (apiPath, optData = {}, req, needToken = true) => {
  const opts = {
    credentials: 'same-origin',
    ...optData,
    headers: {
      'Content-Type': 'application/json',
      'clienttype': 'web',
      'lang': getLang(optData.locale),
      ...(needToken ? { csrfToken: md5(csrfMatches()[1] || '') } : {}),
      ...(optData ? optData.headers : {}),
      ...(await getDeviceInfo()),
    },
  };

  if (req && needToken) {
    opts.headers.Cookie = req.get('cookie');
    opts.headers.csrfToken = md5(req.cookies.cr00 || '');
  }

  try {
    return await requestApi(apiPath, opts, req);
  } catch (err) {
    if (err instanceof NotLoggedInError) {
      if (typeof window !== 'undefined') {
        const { pathname, search } = window.location;
        window.location = getLoginUrl(getLang(optData.locale), pathname + search);
      }
    } else throw err;
  }
  return null;
};

// Get request for gateway
export const gwGet = async (apiPath, optData = {}, req, needToken) => gwRequest(
  apiPath,
  {
    method: 'GET',
    ...optData,
  },
  req,
  needToken
);

// Post request for gateway
export const gwPost = async (apiPath, optData = {}, req, needToken, {
  expire,
  withClientApiCache,
  isExpiredFromResponse,
} = {
  expire: 60,
  withClientApiCache: false,
  isExpiredFromResponse: false,
}) => {
  const getter = () => gwRequest(
    apiPath,
    {
      method: 'POST',
      ...optData,
    },
    req,
    needToken
  );
  if (withClientApiCache) {
    return clientApiCache({
      expire,
      getter,
      key: apiPath,
      isExpiredFromResponse,
    });
  }
  return getter();
};
